export const homeFaqData = [
  {
    question: 'מהי המשמעות של פתיחת הליך חדלות פירעון עבור אדם פרטי?',
    answer:
      'מדובר בהליך משפטי שנועד להסדיר את כלל חובותיו של היחיד, במטרה להביא אותו לשיקום כלכלי ולהפטר מחובות תוך מספר שנים.',
  },
  {
    question: 'מתי כדאי לשקול פתיחה של הליך חדלות פירעון?',
    answer:
      'כאשר סכום החובות גבוה משמעותית מהיכולת הכלכלית של החייב ואין סיכוי ממשי לפרוע אותם בפרק זמן סביר.',
  },
  {
    question: 'האם ניתן להכניס להליך חובות מכל סוג?',
    answer:
      'מרבית סוגי החובות נכללים, אך יש חריגים: מזונות, קנסות פליליים וחובות שנוצרו במרמה – אינם נמחקים.',
  },
  {
    question: 'האם במהלך ההליך מותר לי להמשיך לעבוד ולהתפרנס?',
    answer: 'בהחלט. החוק מעודד השתכרות, והיא אף מהווה בסיס לקביעת התשלום החודשי.',
  },
  {
    question: 'מה קורה לנכסים שברשותי כשאני נכנס להליך חדלות פירעון?',
    answer:
      'רוב הנכסים הופכים לחלק מ"קופת הנשייה", אך החוק מחריג נכסי מחיה בסיסיים, ולעיתים גם רכב או תכולת דירה.',
  },
  {
    question: 'האם פתיחת ההליך עוצרת עיקולים והליכי הוצאה לפועל נגדי?',
    answer:
      'כן. עם קבלת צו פתיחת הליכים מוקפאים כל ההליכים הקיימים ונמנעים הליכים חדשים.',
  },
  {
    question: 'איך נקבע גובה התשלום החודשי שאצטרך לשלם?',
    answer:
      'הממונה בוחן את כלל ההכנסות וההוצאות שלך, לפי נוסחה שמופיעה בנוהל רשמי, כדי לקבוע סכום חודשי הוגן.',
  },
  {
    question: 'האם בן/בת הזוג שלי חשופים להליך או לחובות?',
    answer: 'רק אם הם ערבים או חייבים משותפים. אם לא – ההליך לא יחול עליהם ישירות.',
  },
  {
    question: 'האם ניתן להגיש את הבקשה באופן עצמאי או שצריך עורך דין?',
    answer:
      'ניתן להגיש לבד, אך ייעוץ משפטי מקצועי מגדיל את הסיכוי להצלחה ומונע טעויות קריטיות.',
  },
  {
    question: 'האם אפשר לצאת מהארץ בזמן שההליך מתנהל?',
    answer:
      'רק באישור מיוחד מהממונה או מבית המשפט, ולעיתים בכפוף להפקדת ערבות מתאימה.',
  },
  {
    question: 'מהו צו לשיקום כלכלי ומה המשמעות שלו עבורי?',
    answer:
      'זהו הצו שקובע את מסגרת ההליך לאחר תקופת הביניים – כולל תקופת התשלומים וההגבלות שיחולו עד למתן הפטר.',
  },
  {
    question: 'איך נראה הסוף של ההליך – מהו "הפטר" ומה הוא מעניק לי?',
    answer:
      'הפטר הוא פסק דין שמסיים את ההליך ומוחק את יתרת החובות, למעט החריגים הקבועים בחוק.',
  },
  {
    question: 'האם יש חובת דיווח שוטפת בזמן ההליך?',
    answer: 'כן. תידרש להגיש דו"חות תקופתיים ולהתנהל בשקיפות מול הנאמן והממונה.',
  },
  {
    question: 'מה ההבדל בין חדלות פירעון להליך איחוד תיקים בהוצאה לפועל?',
    answer:
      'חדלות פירעון היא הליך כולל למחיקת חובות; איחוד תיקים הוא הסדר זמני בלבד, ללא הפטר בסיום.',
  },
  {
    question: 'מהו תיק הוצאה לפועל וכיצד הוא נפתח נגדי?',
    answer:
      'תיק הוצאה לפועל נפתח ע"י זוכה (בנק, אדם פרטי, מוסד) לצורך גביית חוב שנקבע בפסק דין, שטר או תביעה על סכום קצוב.',
  },
  {
    question: 'האם ניתן לעצור את ההליכים מיד לאחר פתיחת תיק?',
    answer:
      'כן, אך נדרש לפעול מהר: ניתן להגיש בקשה לעיכוב הליכים, התנגדות או צו תשלומים בתוך מספר ימים.',
  },
  {
    question: 'האם אני יכול להציע פריסה של החוב?',
    answer:
      'בהחלט. ניתן להגיש בקשה לצו תשלומים בהתאם ליכולתך הכלכלית, בצירוף תצהיר ומסמכים תומכים.',
  },
  {
    question: 'מהם הסיכונים אם אני לא מגיב לתיק שנפתח?',
    answer:
      'ההליך ימשיך, עלולים להיות עיקולים על חשבון הבנק, משכורת, רכב, ואף צו עיכוב יציאה מהארץ.',
  },
  {
    question: "מהו עיקול צד ג' ומתי משתמשים בו?",
    answer:
      'זהו עיקול שמופנה לגורם שמחזיק בכספים שלך (כמו בנק או מעסיק), כדי להעביר אותם לזוכה.',
  },
  {
    question: 'האם אפשר להגיש בקשה לאיחוד תיקים?',
    answer:
      'כן, אם יש לך מספר תיקים פתוחים – ניתן לבקש לאחדם לתשלום חודשי אחד באמצעות "צו איחוד".',
  },
  {
    question: 'איך ניתן להסיר עיכוב יציאה מהארץ שהוטל עליי?',
    answer: "יש להגיש בקשה מנומקת, ולעיתים תידרש להפקיד ערבות או להציע התחייבות של צד ג'.",
  },
  {
    question: 'קיבלתי התראה על צו הבאה – מה זה אומר?',
    answer:
      'פירושו שעליך להתייצב בלשכת ההוצאה לפועל. אם לא תעשה כן, המשטרה עשויה להביאך בכפייה.',
  },
];
